import ATag from './index.vue';

ATag.install = app => {
  app.component(ATag.name, ATag);
};

export default ATag;
